import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const StyledHistoryDescription = styled(Typography)`
  font-family: 'Futura New Regular', serif;
  font-weight: normal;
  font-size: 1.25rem;
  color: #59443f;
  line-height: 1.875rem;
  max-width: 31rem;
  margin: 0 auto 2.2rem auto;
`;

export const HistoryDiv = styled.div`
  padding: 6rem 0 3.4rem;
`;
